import React, { ReactNode } from 'react';
import { Box, FormGroup, Typography } from '@mui/material';

export const SettingsDialogContainer = (props: { readonly children: ReactNode }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>{props.children}</Box>
);

interface ColumnProps {
  readonly title: string;
  readonly children: ReactNode;
}

export const SettingsDialogColumn = (props: ColumnProps) => (
  <Box sx={{ mx: 1, p: 1 }}>
    <Typography variant="h6" sx={{ mb: 1 }}>
      {props.title}
    </Typography>

    <FormGroup sx={{ display: 'flex', flexDirection: 'column' }}>{props.children}</FormGroup>
  </Box>
);
